import React from 'react'
import i18n from '../../../../../../../lib/i18n'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addSlidePdf } from '../../../../../actions';
import { notification } from 'antd';


const limitCount = 150;

function UploadSliderPdf({countImgs = 0}) {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch()
  const slider = useSelector(state => state.slider.slider)
  const onChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      if(file.type !== 'application/pdf'){
        throw new Error('Only PDF allowed');
      }

      await dispatch(addSlidePdf(file, slider.id));
    } catch (error) {
      api.error({
        message: i18n('sl_slide_pdf_title'),
        description: i18n('sl_slide_pdf_msg') || 'Error uploading PDF',
      })
    }
  }

  return (
    <label>
      {contextHolder}
      {i18n('sl_add_slide_pdf') || 'Upload PDF'}
      {countImgs < limitCount && <input style={{display: 'none'}} type='file' accept='application/pdf' onChange={onChange}  />}
    </label>
  )
}

export default UploadSliderPdf
